// =============================================================================
// connection-progress.ts – Horizontal progress bar for connection wait time
// =============================================================================

export function renderProgressBar(
  waitMin: number,
  thresholds: { tightMin: number; goodMin: number; longMin: number }
): string {
  const percent = Math.min(100, Math.max(0, (waitMin / thresholds.longMin) * 100));
  let colorClass = "long";
  let stateLabel = "lunga";

  if (waitMin < 0) {
    colorClass = "missed";
    stateLabel = "perso";
  } else if (waitMin < thresholds.tightMin) {
    colorClass = "tight";
    stateLabel = "stretta";
  } else if (waitMin <= thresholds.goodMin) {
    colorClass = "good";
    stateLabel = "buona";
  } else if (waitMin <= thresholds.longMin) {
    colorClass = "calm";
    stateLabel = "comoda";
  }

  const isTight = colorClass === "tight" ? "pulse" : "";
  const labelUpper = stateLabel.toUpperCase();
  const waitText = waitMin < 0 ? "partito" : `${waitMin} min attesa`;

  return `
    <div class="conn-progress-container">
      <div class="conn-progress">
        <div class="conn-progress-fill ${colorClass} ${isTight}" style="width: ${percent}%;"></div>
      </div>
      <span class="conn-progress-label">${waitText} <span class="conn-progress-status ${colorClass}">[${labelUpper}]</span></span>
    </div>
  `;
}
